import React from 'react'

export default function AboutBanner() {
  return (
    <div className="pt-24 sm:pt-20 md:pt-24 lg:pt-[12.0625rem]">
      <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16 w-4/5 mx-auto">
        <div className="relative">
          <div className="flex justify-center">
            <div className="text-center ">
              <h1 data-aos="fade-up" data-aos-delay="100" className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lowercase tracking-[-.04em] leading-tight sm:leading-snug">
                About us
              </h1>
          <div className="md:text-3xl text-2xl md:leading-10 tracking-tight text-white pt-6 sm:pt-8 md:pt-10 lg:pt-12 xl:pt-[4.75rem] font-Matter">
                <p data-aos="fade-up" data-aos-delay="200">
                  We are committed to providing high-quality medical imaging services with{' '}
                  <span className="text-[#cfa751]">
                    excellent diagnostic results focused on patients’ wellness
                  </span>
                  , with continuous investment in{' '}
                  <span className="text-[#cfa751]">advanced technologies</span> and{' '}
                  <span className="text-[#cfa751]">facilities</span>.
                  <br />
                  <br />
                  Discover our core values and our story below.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}